<template>
    <div style="width:100%;height:100%" ref="chart"></div>
</template>

<script>
    import {
        //传入chart借基础类型和要设置的对象
        chartMerge,
        //添加业务通用图表或者初始化覆盖业务组件
        insertChartConfig,
        //重置theme色系改变成自己业务所需要的色系
        resetColorConfig
    } from "echarts-config";
    import echarts from "echarts";

    export default {
        components: {},
        name: "",
        props: {
            data: {
                type: Object,
                default: {}
            },
            barData: {
                type: [Array, Object]
            },
            chartType: {
                type: String,
                default: "lineBar"
            },
            // 开启初始动画
            play: {
                type: Boolean,
                default: false
            },
            waitFor: {
                type: Boolean,
                default: false
            },
            // 开启轮播动画
            animation: {
                type: Boolean,
                default: false
            }
        },
        data() {
            let charts = {};
            return {
                time: null,
                open: false,
                getChart : ()=>{
                    return charts;
                }
            };
        },
        watch: {
            play: {
                handler(val) {
                    const myChart = this.getChart();
                    if (val) {
                        let option = myChart.chart.getOption();
                        this.clearOption(option);
                        this.clearTime();
                        this.initPlay();
                    } else {
                        let option = myChart.chart.getOption();
                        // setTimeout(() => {
                        //     this.clearOption(option);
                        // }, 2000);
                        this.clearTime();
                        this.closeAnimate(option);
                    }
                },
                deep: true
            },
            barData: {
                handler(v) {
                    if (v && v.data) {
                        let chart = this.getChart().chart;
                        let keys = Object.keys(v);
                        if (v.length === 3) {
                            chart && chart.setOption({
                                series: [{
                                    data: v.item1
                                },{
                                    data: v.item2
                                }],
                                xAxis: {
                                    data: v.xData
                                }
                            });
                        } else {
                            chart && chart.setOption({
                                series: [{
                                    type: "bar",
                                    data: v.data.bar[0]
                                }, {
                                    type: "bar",
                                    data: v.data.bar[1]
                                }, {
                                    type: "line",
                                    itemStyle: {
                                        normal: {
                                            color: "rgba(46,230,168,1)"
                                        }
                                    },
                                    data: v.data.line
                                }],
                                xAxis: [{
                                    type: "category",
                                    data: v.xData
                                }, {
                                    type: "category",
                                    data: v.xData
                                }, {
                                    type: "category",
                                    data: v.xData
                                }]
                            });
                        }
                    }
                },
                deep: true
            }
        },
        mounted() {
            window._CHART_THEMETYPE_ = "dark";
            if (this.waitFor) {
                this.open = true;
            }
            this.init();
        },
        methods: {
            init() {
                const myChart = this.getChart();
                if ( myChart.chart ) {
                    window.removeEventListener(
                        "resize",
                        myChart.chart.resize,
                        false
                    );
                    myChart.chart.dispose();
                    myChart.chart = null;
                }
                myChart.chart = echarts.init(this.$refs.chart);
                let option = chartMerge(
                    {
                        chartType: this.chartType
                    },
                    JSON.parse( JSON.stringify(this.data) )
                );
                myChart.chart.setOption(option, true);
                this.resizeChart = myChart.chart.resize;
                window.addEventListener("resize", myChart.chart.resize);
                this.initPlay();
            },
            initPlay() {
                const myChart = this.getChart();
                if (this.play && myChart.chart) {
                    if (this.open) {
                        this.open = false;
                        this.initAnimation();
                    } else {
                        myChart.chart.dispatchAction({
                            type: "showTip",
                            seriesIndex: 0,
                            dataIndex: -1
                        });
                        setTimeout(() => {
                            this.initAnimation();
                        }, 800);
                    }
                }
            },
            // 轮询
            initAnimation() {
                const myChart = this.getChart();
                let option = chartMerge(
                    {
                        chartType: this.chartType
                    },
                    this.data
                );
                myChart.chart.clear();
                myChart.chart.setOption(option, true);

                // 开启轮播动画
                if (!this.animation) return false;

                // 清除定时
                this.clearTime();

                let app = {
                    currentIndex: -1
                };
                myChart.chart.dispatchAction({
                    type: "showTip",
                    seriesIndex: 0,
                    dataIndex: 0
                });

                this.time = setInterval(() => {
                    let dataLen = this.data.series[0].data.length;
                    app.currentIndex = (app.currentIndex + 1) % dataLen;
                    //取消之前高亮的图形;
                    // this.myChart.dispatchAction({
                    //     type: "downplay",
                    //     seriesIndex: 0,
                    //     dataIndex: app.currentIndex
                    // });
                    // 高亮当前图形
                    myChart.chart.dispatchAction({
                        type: "highlight",
                        seriesIndex: 0,
                        dataIndex: app.currentIndex
                    });
                    // 显示 tooltip
                    myChart.chart.dispatchAction({
                        type: "showTip",
                        seriesIndex: 0,
                        dataIndex: app.currentIndex
                    });
                }, 2000);
            },
            clearOption(option) {
                const myChart= this.getChart();
                option.series.forEach(element => {
                    let list = [];
                    element.data.forEach(option => {
                        if (element.type === "line") {
                            list.push(-100);
                        } else {
                            list.push(0);
                        }
                    });
                    element.data = list;
                });
                myChart.chart.setOption(option);
            },
            // 关闭动画
            closeAnimate(option) {
                const myChart= this.getChart();
                myChart.chart.dispatchAction({
                    type: 'hideTip'
                });
            },
            clearTime() {
                if (this.time) {
                    window.clearInterval(this.time);
                }
            }
        },
        beforeDestroy() {
            const myChart = this.getChart();
            if ( myChart.chart ) {
                window.removeEventListener("resize", myChart.chart.resize, false);
                myChart.chart.dispose();
                myChart.chart = null;
                this.clearTime();
            }
        }
    };
</script>
